module.exports = __webpack_public_path__ + "static/media/login.806027db.jpg";